import React from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { useEntityNavigate as useNavigate } from '../../navigation/navigation'
import EntityForm from '../../components/EntityForm'
import { Button } from '../../components/ui'
import './Company.css'

function ClientEdit() {
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const isNew = location.pathname.endsWith('/new') || id === 'new'
  const editId = isNew ? null : id

  return (
    <div className="company-page">
      <div className="page-header">
        <Button variant="ghost" onClick={() => navigate(isNew ? '/company/clients' : `/client/${editId}`)} className="btn-back">
          ← Назад
        </Button>
      </div>
      <EntityForm
        entityType="clients"
        entityId={editId}
        context={{}}
        title={isNew ? 'Новый клиент' : 'Редактирование клиента'}
      />
    </div>
  )
}

export default ClientEdit
